import React from "react";
import { socialLinks } from "@/data/social";
import { trackEvent } from "@/lib/analytics";

/**
 * variant: "icons" (compact round icons) | "cards" (labeled cards)
 * size: "sm" | "md"
 */
export default function SocialLinks({ variant = "icons", size = "md", className = "", showLabels = false }) {
  return (
    <ul className={`social-links social-links-${variant} social-links-${size} ${className}`}>
      {socialLinks.map((s) => (
        <li key={s.key}>
          <a
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            title={s.label}
            data-testid={`social-${s.key}`}
            onClick={() => trackEvent("Contact", { source: `social-${s.key}` })}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d={s.icon} />
            </svg>
            {(showLabels || variant === "cards") && <span className="social-link-label">{variant === "cards" ? s.label : s.short}</span>}
          </a>
        </li>
      ))}
    </ul>
  );
}
